import { createFileRoute } from "@tanstack/react-router";

import { GdprPage } from "@/components/marketing/gdpr-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/gdpr")({
  head: () => pageHead("gdpr"),
  component: GdprPage,
});
